require('./base.js');
require('./jquery_ui.js');
require('./js_maps.js');
require('./sample_graph.js');

require('../../../public/javascripts/jquery/jquery.scrollto.js');
require('../../../public/javascripts/fullpage.js');
require('../../../public/javascripts/strftime.js');
require('../../../public/javascripts/routes/common.js');
require('../../../public/javascripts/segments/show.js');




// WEBPACK FOOTER //
// ./app/assets/javascripts/segments-show.js